import Vue from 'vue'
import { Tabbar, TabbarItem, NavBar, Toast, Form, Field, Button, Cell, CellGroup, Tabs, Tab, Icon, List, PullRefresh } from 'vant'

Vue.use(Form)
Vue.use(Field)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(NavBar)
Vue.use(Toast)
Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Tabs)
Vue.use(Tab)
Vue.use(Icon)
Vue.use(List)
Vue.use(PullRefresh)
